import React from 'react';
interface CardProps {
  title?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
}
export function Card({
  title,
  actions,
  children,
  className = '',
  footer
}: CardProps) {
  return <div className={`bg-white border border-[#dddbda] rounded-[4px] shadow-sm ${className}`} data-id="element-280">
      {(title || actions) && <div className="flex items-center justify-between px-4 py-3 border-b border-[#dddbda]" data-id="element-281">
          {title && <h3 className="text-base font-bold text-[#080707] flex items-center gap-2" data-id="element-282">
              {title}
            </h3>}
          {actions && <div className="flex items-center gap-2" data-id="element-283">{actions}</div>}
        </div>}
      <div className="p-4" data-id="element-284">{children}</div>
      {footer && <div className="px-4 py-2 bg-[#f3f2f2] border-t border-[#dddbda] rounded-b-[4px]" data-id="element-285">
          {footer}
        </div>}
    </div>;
}